(function($){
  $("#gform_confirmation_wrapper_2").append('<div class="FormComplete-wrapper"><a href="' + window.location.origin +' " class="FormComplete-anchor"> <span class="FormComplete-anchor--text"> Return To Homepage </span> </a></div>');
}(jQuery));
